


const endStatus = [
    {
        name:'Semua',
        value:'notActive'
    },
    {
        name:'Terkirim',
        value:'delivered'
    },
    {
        name:'Cancel',
        value:'cancelled'
    },
    {
        name:'Kurir Tidak Ketemu',
        value:'courierNotFound'
    },
    {
        name:'Retur',
        value:'returned'
    },
    {
        name:'Dihancurkan',
        value:'disposed'
    },
    {
        name:'Ditolak',
        value:'rejected'
    }
]
export default endStatus